export const shipToOptions = [
    { id: "client", name: 'Client' },
    { id: "decorator", name: 'Decorator' },
    { id: "elite", name: 'Elite Promotional Marketing' },
    { id: "other_supplier", name: 'Other Supplier' },
];

export const shippingAccountOptions = [
    { id: "supplier", name: "Supplier's Account" },
    { id: "our", name: "Our Account" },
    { id: "client", name: "Client's Account" },
    { id: "other", name: "Other" },
]

export const shippingMethodOptions = [
    { id: "Ground - Best way", name: 'Ground - Best way' },
    { id: "Air - Best way", name: 'Air - Best way' },
    { id: "Customer Pick up", name: 'Customer Pick up' },
    /*
    { id: "Flyen S", name: 'Flyen S' },
    { id: "Sales Person To Deliver", name: 'Sales Person To Deliver' },
    { id: "Next Day Air", name: 'Next Day Air' },
    { id: "Other", name: 'Other' },
    { id: "Ground - UPS", name: 'Ground - UPS' },
    { id: "Purolator", name: 'Purolator' },
    { id: "Ground - FedEx", name: 'Ground - FedEx' },
    { id: "Canada Post", name: 'Canada Post' },*/
];

export const decoratorShipToOptions = [
    { id: "client", name: 'Client' },
    { id: "elite", name: 'Elite Promotional Marketing' },
];

export const labelStyle = {
    fontSize: '14px !important',
    fontFamily: 'Nunito !important',
    color: '#555 !important'
};
